import { useState } from 'react';

/** Owns which step is current and the first/last/next/back arithmetic every wizard otherwise
 * reimplements on its own currentStepIndex state. Paired with components/WizardShell.tsx. */
export function useWizardSteps(stepCount: number, initial = 0) {
  const [currentStepIndex, setCurrentStepIndex] = useState(initial);
  const clamp = (i: number) => Math.max(0, Math.min(stepCount - 1, i));
  return {
    currentStepIndex,
    goTo: (i: number) => setCurrentStepIndex(clamp(i)),
    goNext: () => setCurrentStepIndex((i) => clamp(i + 1)),
    goBack: () => setCurrentStepIndex((i) => clamp(i - 1)),
    isFirst: currentStepIndex === 0,
    isLast: currentStepIndex === stepCount - 1,
  };
}
